import {
  Card,
  CardContent,
  CardHeader,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../components/CustomLoader";
import errorHandler from "../../utils/errorHandler";
import { toast } from "react-toastify";
import { NotificationServices } from "../../services/AllServices";

export default function ListNotification() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const res = await NotificationServices.getNotification();
        console.log(res);
        const notificationData = formatNotificationData(res?.data?.data);
        setData(notificationData);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  const formatNotificationData = (notification) => {
    const booleanFields = Object.keys(notification).filter(
      (key) =>
        typeof notification[key] === "boolean" && key !== "_id"
    );

    return booleanFields.map((field) => ({
      _id: notification._id,
      type: field
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase()), // Human-readable
      isActive: notification[field],
      field,
    }));
  };

  const toggleNotificationStatus = async (id, field, currentStatus) => {
    const updatedStatus = {
      [field]: !currentStatus,
    };

    try {
      const res = await NotificationServices.updateStatus({ id, ...updatedStatus });
      if (res?.status === 200) {
        toast.success(res?.data?.message, { toastId: "success" });
        setData((prevData) =>
          prevData.map((item) =>
            item.field === field
              ? { ...item, isActive: updatedStatus[field] }
              : item
          )
        );
      } else {
        toast.error(res?.data?.message, { toastId: "error" });
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const columns = [
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <Tooltip title={row.isActive ? "Deactivate" : "Activate"} placement="top">
          <Switch
            checked={row.isActive}
            onChange={() =>
              toggleNotificationStatus(row._id, row.field, row.isActive)
            }
            color={row.isActive ? "success" : "default"}
          />
        </Tooltip>
      ),
      center: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: "#f5f5f5",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
      },
    },
  };

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: "900px",
        margin: "auto",
        mt: 4,
        boxShadow: 3,
      }}
    >
      <CardHeader
        title={
          <Typography variant="h5" component="div">
            Notification Setting
          </Typography>
        }
      />
      <CardContent>
        <DataTable
          customStyles={customStyles}
          columns={columns}
          data={data}
          progressPending={loading}
          progressComponent={<CustomLoader />}
          responsive
          pagination
          highlightOnHover
          noHeader
        />
      </CardContent>
    </Card>
  );
}
